import { ITransitions } from '../../sm.types';

const transitions:ITransitions = {
    'allIneligibileMembers': {
        conditionId: 'areAllIneligibileMembers',
        stateId: 'isBlank'
    },
    'insideOEPEnrollmentWindow': {
        conditionId: 'isInsideOEPEnrollmentWindow',
        stateId: 'insideOEPWindow'
    },
    'outsideOEP_SEPApplication': {
        conditionId: 'isSEPApplication',
        stateId: 'outsideOEP_SEP'
    },
    'outsideOEP_QEorOEApplication': {
        conditionId: 'isOEorQEApplication',
        stateId: 'outisdeOEP_QEPorOE'
    },
    'insideOEP_SEPapplication': {
        conditionId: 'isSEPApplication',
        stateId: 'insideOEP_SEP'
    },
    'insideOEP_QEPapplication': {
        conditionId: 'isQEPApplication',
        stateId: 'isChangePlan'
    },
    'insideOEP_OEapplication': {
        conditionId: 'isOEApplication',
        stateId: 'insideOEP_OE'
    },
    'enrollmentIdSimilartoPriorApplicationId': {
        conditionId: 'isEnrollmentIdSimilartoPriorApplicationId',
        stateId: 'isChangePlan'
    },
    'enrollmentIdNotEqualtoPriorApplicationId': {
        conditionId: 'isEnrollmentIdNotEqualtoPriorApplicationId',
        stateId: 'isFinalizePlan'
    },
    'groundRenewal': {
        conditionId: 'isGroupRenewal',
        stateId: 'isRenewOrChangePlan'
    },
    'nonGroupRenewal': {
        conditionId: 'isNoGroupRenewal',
        stateId: 'isChangePlan'
    },
    'outsideOEP_SEPenrollementNotSimiarToPriorApplicationId': {
        conditionId: 'isEnrollmentIdNotEqualtoPriorApplicationId',
        stateId: 'newApplication'
    },
    'unenrolledDentalMembers': {
        conditionId: 'hasUnenrolledDentalMembers',
        stateId: 'isBlank'
    },
    'allEnrolledDentalMembers': {
        conditionId: 'isHealthOrAllDentalEnrolledMembers',
        stateId: 'isFinalizePlan'
    },
    'allowedToChangePlan': {
        conditionId: 'isAllowedToChangePlan',
        stateId: 'isChangePlan'
    },
    'notAIANMemberOrLowFPL': {
        conditionId: 'isNotAIANMemberOrLowFPL',
        stateId: 'isBlank'
    },
    'enrollmentCoverageDateInThisMonth': {
        conditionId: 'isEnrollmentCoverageDateInThisMonth',
        stateId: 'isChangePlan'
    },
    'enrollmentCoverageDateNotInThisMonth': {
        conditionId: 'isEnrollmentCoverageDateNotInThisMonth',
        stateId: 'isBlank'
    },
    'outsideOEP_SEPAllowToChangePlan': {
        conditionId: 'isAllowedToChangePlan',
        stateId: 'isChangePlan'
    },
    'groupAllowedToChangePlan': {
        conditionId: 'isGroupAllowedToChangePlan',
        stateId: 'isChangePlan'
    },
    'isBlank': {
        conditionId: 'defaultCondition',
        stateId: 'isBlank'
    },
};

export default transitions;